module.exports = __webpack_public_path__ + "assets/img/9.8e53e784.png";